import { render, staticRenderFns } from "./ClientUsersList.vue?vue&type=template&id=079422c5&scoped=true&"
import script from "./ClientUsersList.vue?vue&type=script&lang=js&"
export * from "./ClientUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079422c5",
  null
  
)

export default component.exports